export const TRACES_PENDING_POLL_MS = 5000;

export interface TracesGeoState {
  tracesGeoJson?: string | null;
  tracesGeoPending?: boolean;
}

export interface TracesPendingWatch {
  fetchSite: () => Promise<TracesGeoState | undefined>;
  onUpdate: (state: TracesGeoState) => void;
}

export function watchTracesPending({ fetchSite, onUpdate }: TracesPendingWatch): () => void {
  let stopped = false;
  let inFlight = false;
  const timer = setInterval(poll, TRACES_PENDING_POLL_MS);

  function stop(): void {
    stopped = true;
    clearInterval(timer);
  }

  async function poll(): Promise<void> {
    if (inFlight) return;
    inFlight = true;
    try {
      const state = await fetchSite();
      if (stopped || !state) return;
      onUpdate(state);
      if (!state.tracesGeoPending) stop();
    } catch {
      return;
    } finally {
      inFlight = false;
    }
  }

  return stop;
}
